import styled from 'styled-components';
import { getSizeBy, getColorShade, getThemeProp } from '../../../src/styled/utils';
import { Body2 } from '../typography';
export const Wrapper = styled.div `
  position: relative;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: ${getSizeBy(8)};
  height: ${getSizeBy(8)};
  overflow: hidden;
  background-color: ${getColorShade('onSurface', 'outline')};
  border-radius: ${({ $variant, theme }) => {
    switch ($variant) {
        case 'rounded':
            return '50%';
        case 'square':
            return `${getThemeProp('borderRadius')({ theme })}px`;
        default:
            return '50%';
    }
}};
`;
export const AvatarImage = styled.img `
  display: ${({ $isLoaded }) => ($isLoaded ? 'block' : 'none')};
  width: 100%;
  height: 100%;
  object-fit: cover;
  color: transparent;
  text-align: center;
`;
export const Fallback = styled(Body2) `
  color: ${getColorShade('onSurface', 'lowEmphasis')};
`;
